enum ModuleStatus {
    DRAFT = "draft",
    PUBLISHED = "published",
}

export default ModuleStatus;
